import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'react-router';
import { StateObservable } from 'redux-observable';

import { SET_AUTH_SOCKET_CHANNEL_STATUS } from 'actionTypes/user';
import { DESKTOP_WALLET_OPEN } from 'actionTypes/wallet';
import { isRNWebview } from 'constants/constants';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { allOpenPositionsSelector } from 'selectors/holdingsSelectors';
import { appDrawerSelector } from 'selectors/otherSelectors';
import { selectIsAuthChannelFailed } from 'selectors/user';
import IState from 'types/Istore';

export const hasAnyOpenPollingAsset = (stateStream: StateObservable<IState>) => {
  const allHoldings = allOpenPositionsSelector(stateStream.value);
  const hasAnyOpenHolding = allHoldings?.length > 0;
  return hasAnyOpenHolding;
};

export const shouldStartPolling = ({
  type,
  payload,
  state$,
}: {
  type: string;
  payload: any;
  state$: StateObservable<IState>;
}) => {
  let isTradeorPositionsPage = false;
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  if (isDesktop && [SET_AUTH_SOCKET_CHANNEL_STATUS, LOCATION_CHANGE].includes(type)) {
    const locationObj = type === LOCATION_CHANGE ? payload : window;
    let { pathname } = locationObj.location;
    pathname = pathname.replace('/app', '');
    const isTradePage = !!matchPath(
      pathname,
      '/:contractType?/trade/:assetSymbol?/:productSymbol?'
    )?.isExact;
    const isPositionsPage = !!matchPath(pathname, '/account/positions')?.isExact;
    isTradeorPositionsPage = isTradePage || isPositionsPage;
  }

  const { activeTab } = appDrawerSelector(state$.value);
  const isHomeOrPositionsTab =
    !isDesktop &&
    (
      [APP_DRAWER_TAB_ID_MAPPING.POSITIONS, APP_DRAWER_TAB_ID_MAPPING.HOME] as any
    ).includes(activeTab);

  const isHomeOrLoaderRouteinNativeApp =
    type === LOCATION_CHANGE &&
    isRNWebview() &&
    (payload.location.pathname.endsWith('/loader') ||
      payload.location.pathname.endsWith('/home'));

  const hasAnyOpenHolding = hasAnyOpenPollingAsset(state$);
  const isAuthConnectFailed = selectIsAuthChannelFailed(state$.value);

  const isDesktopWalletOpen =
    type === DESKTOP_WALLET_OPEN && payload === true && isDesktop;
  const shouldPoll =
    isAuthConnectFailed &&
    hasAnyOpenHolding &&
    !isHomeOrLoaderRouteinNativeApp &&
    (isTradeorPositionsPage || isHomeOrPositionsTab || isDesktopWalletOpen);
  return shouldPoll;
};
